const INITIAL_STATE = {
    showLoading: false,
    showProcessing: false,
    textProcessing: undefined
};

export default function loadingReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    if (action.type === 'START_LOADING' || action.type === 'END_LOADING') {
        return {
            ...state,
            showLoading: action.showLoading
        };
    }

    if (action.type === 'START_PROCESSING' || action.type === 'END_PROCESSING') {
        return {
            ...state,
            textProcessing: action.textProcessing,
            showProcessing: action.showProcessing
        };
    }

    return state;
}
